import { createFileRoute } from '@tanstack/react-router';

import { QuizGradingPage } from '@/pages/quiz-grading';

type QuizGradingSearchParams = {
  contentId: string;
  courseId: string;
};

export const Route = createFileRoute('/_user/courses/quiz-grading')({
  validateSearch: (search: Record<string, string>): QuizGradingSearchParams => {
    return {
      contentId: search.contentId ?? '',
      courseId: search.courseId ?? '',
    };
  },
  component: QuizGradingPage,
});
